import sanityClient from "@sanity/client";

export default sanityClient({
  projectId: "windffuw", // find this at manage.sanity.io or in your sanity.json
  dataset: process.env.NODE_ENV === "production" ? "production" : "test", // test dataset
  useCdn: true,
  apiVersion: "2021-03-25"
});
